// @flow

import ReduceStore from 'PMT/flux/ReduceStore';

// -- constant
import Events from 'constants/Events';
import ActionTypes from 'constants/ActionTypes';

// -- entity
import ApiError from 'PMT/entities/ApiError';
import {
  RestaurantMenu,
  Menu,
  Product,
  ProductCategory,
  ProductOption,
  UpsellingCategory
} from 'PMT/entities/menu';

// -- vars


class RestaurantMenuStore extends ReduceStore {

  getInitialState() {
    return {
      isFetching: false,
      /**
      * @type RestaurantMenu
      */
      restaurantMenu: null,
      /**
      * @type ApiError
      */
      apiError: null,
      /**
      * @type Menu
      */
      createdMenu: null,
      /**
      * @type Product
      */
      createdProduct: null,
      /**
      * @type ProductCategory
      */
      createdCategory: null,
      /**
      * @type ProductOption
      */
      createdProductOption: null,
      /**
      * @type UpsellingCategory
      */
      createdUpsellingCategory: null,
    }
  }

  isEmitingCustomEvents(): boolean {
    return true;
  }

  getStateObjectsMap() {
    return {
      isFetching: false,
      apiError: new ApiError(),
      restaurantMenu: new RestaurantMenu(),
      createdMenu: new Menu(),
      createdProduct: new Product(),
      createdCategory: new ProductCategory(),
      createdProductOption: new ProductOption(),
      createdUpsellingCategory: new UpsellingCategory(),
    }
  }

  getState() {
    return this._state
  }

  getApiError(): ApiError {
    return this._state.apiError;
  }

  getRestaurantMenu(): RestaurantMenu {
    return this._state.restaurantMenu;
  }

  getCreatedMenu(): Menu {
    return this._state.createdMenu;
  }

  getCreatedProduct(): Product {
    return this._state.createdProduct;
  }

  getCreatedCategory(): ProductCategory {
    return this._state.createdCategory;
  }

  getCreatedProductOption(): ProductOption {
    return this._state.createdProductOption;
  }

  getCreatedUpsellingCategory(): UpsellingCategory {
    return this._state.createdUpsellingCategory;
  }

  reduce(state, action, nextState) {
    switch (action.type) {

      case ActionTypes.LOGOUT:
      case ActionTypes.GET_RESTAURANT_FOR_GROUP_REQUEST:
        return this.getInitialState();

      //
      // RestaurantMenu - GET
      //

      case ActionTypes.GET_RESTAURANT_MENU:
        nextState.isFetching = true;
        nextState.restaurantMenu = null;
        nextState.apiError = null;

        this.emitEvent(Events.ON_LOADING_RESTAURANT_MENU);
        return nextState;

      case ActionTypes.GET_RESTAURANT_MENU_RESPONSE_SUCCESS:
      case ActionTypes.GET_RESTAURANT_MENU_WITH_SYNCHRONIZATION_RESPONSE_SUCCESS:
        nextState.isFetching = false;
        nextState.restaurantMenu = action.restaurantMenu;
        nextState.apiError = null;

        this.emitEvent(Events.ON_LOADING_RESTAURANT_MENU_SUCCESS);
        return nextState;

      case ActionTypes.GET_RESTAURANT_MENU_RESPONSE_FAILURE:
      case ActionTypes.GET_RESTAURANT_MENU_WITH_SYNCHRONIZATION_RESPONSE_FAILURE:
        nextState.isFetching = false;
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_LOADING_RESTAURANT_MENU_ERROR);
        return nextState;

      //
      // RestaurantMenu - UPDATED
      //

      case ActionTypes.PUT_RESTAURANT_MENU_RESPONSE_SUCCESS:
        nextState.restaurantMenu = action.restaurantMenu;
        nextState.apiError = null;

        this.emitEvent(Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS);
        return nextState;

      case ActionTypes.PUT_RESTAURANT_MENU_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_UPDATE_RESTAURANT_MENU_ERROR);
        return nextState;

      //
      // PRODUCT - UPDATED
      //

      case ActionTypes.PUT_RESTAURANT_MENU_PRODUCT_RESPONSE_SUCCESS:
        nextState.restaurantMenu.updateProduct(action.product);
        nextState.apiError = null;

        this.emitEvent(Events.ON_UPDATE_RESTAURANT_MENU_PRODUCT_SUCCESS);
        return nextState;

      case ActionTypes.PUT_RESTAURANT_MENU_PRODUCT_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_UPDATE_RESTAURANT_MENU_PRODUCT_ERROR);
        return nextState;


      //
      // PRODUCT - DELETED IMAGE
      //

      case ActionTypes.DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_SUCCESS:
        nextState.restaurantMenu.updateProduct(action.product);
        nextState.apiError = null;

        this.emitEvent(Events.ON_DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_SUCCESS);
        return nextState;

      case ActionTypes.DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_ERROR);
        return nextState;


      //
      // PRODUCT - DELETED
      //

      case ActionTypes.DELETE_RESTAURANT_MENU_PRODUCT_RESPONSE_SUCCESS:
        nextState.restaurantMenu.deleteProduct(action.product);
        nextState.apiError = null;

        this.emitEvent(Events.ON_DELETE_RESTAURANT_MENU_PRODUCT_SUCCESS);
        return nextState;

      case ActionTypes.DELETE_RESTAURANT_MENU_PRODUCT_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_DELETE_RESTAURANT_MENU_PRODUCT_ERROR);
        return nextState;

      //
      // PRODUCT - CREATED
      //

      case ActionTypes.POST_RESTAURANT_MENU_PRODUCT_RESPONSE_SUCCESS:
        nextState.restaurantMenu.addProduct(action.product);
        nextState.createdProduct = action.product;
        nextState.apiError = null;

        this.emitEvent(Events.ON_CREATE_RESTAURANT_MENU_PRODUCT_SUCCESS);
        return nextState;

      case ActionTypes.PUT_RESTAURANT_MENU_PRODUCT_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_CREATE_RESTAURANT_MENU_PRODUCT_ERROR);
        return nextState;

      //
      // PRODUCT OPTION - UPDATED
      //

      case ActionTypes.PUT_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS:
        nextState.restaurantMenu.updateProductOption(action.productOption);
        nextState.apiError = null;

        this.emitEvent(Events.ON_UPDATE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS);
        return nextState;

      case ActionTypes.PUT_RESTAURANT_MENU_PRODUCT_OPTION_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_UPDATE_RESTAURANT_MENU_PRODUCT_OPTION_ERROR);
        return nextState;

      case ActionTypes.DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_SUCCESS:
        nextState.restaurantMenu.updateProductOption(action.productOption);
        nextState.apiError = null;

        this.emitEvent(Events.ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_SUCCESS);
        return nextState;

      case ActionTypes.DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_ERROR);
        return nextState;

      //
      // PRODUCT OPTION - DELETED
      //

      case ActionTypes.DELETE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS:
        nextState.restaurantMenu.deleteProductOption(action.productOption);
        nextState.apiError = null;

        this.emitEvent(Events.ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS);
        return nextState;

      case ActionTypes.DELETE_RESTAURANT_MENU_PRODUCT_OPTION_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_ERROR);
        return nextState;

      //
      // PRODUCT OPTION - CREATED
      //

      case ActionTypes.POST_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS:
        nextState.restaurantMenu.addProductOption(action.productOption);
        nextState.createdProductOption = action.productOption;
        nextState.apiError = null;

        this.emitEvent(Events.ON_CREATE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS);
        return nextState;

      case ActionTypes.POST_RESTAURANT_MENU_PRODUCT_OPTION_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_CREATE_RESTAURANT_MENU_PRODUCT_OPTION_ERROR);
        return nextState;

      //
      // MENU - UPDATED
      //

      case ActionTypes.PUT_RESTAURANT_MENU_MENU_RESPONSE_SUCCESS:
        nextState.restaurantMenu.updateMenu(action.menu);
        nextState.apiError = null;

        this.emitEvent(Events.ON_UPDATE_RESTAURANT_MENU_MENU_SUCCESS);
        return nextState;

      case ActionTypes.PUT_RESTAURANT_MENU_MENU_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_UPDATE_RESTAURANT_MENU_MENU_ERROR);
        return nextState;

      case ActionTypes.DELETE_RESTAURANT_MENU_MENU_IMAGE_RESPONSE_SUCCESS:
        nextState.restaurantMenu.updateMenu(action.menu);
        nextState.apiError = null;

        this.emitEvent(Events.ON_DELETE_RESTAURANT_MENU_MENU_IMAGE_SUCCESS);
        return nextState;

      case ActionTypes.DELETE_RESTAURANT_MENU_MENU_IMAGE_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_DELETE_RESTAURANT_MENU_MENU_IMAGE_ERROR);
        return nextState;

      //
      // MENU - DELETED
      //

      case ActionTypes.DELETE_RESTAURANT_MENU_MENU_RESPONSE_SUCCESS:
        nextState.restaurantMenu.deleteMenu(action.menu);
        nextState.apiError = null;

        this.emitEvent(Events.ON_DELETE_RESTAURANT_MENU_MENU_SUCCESS);
        return nextState;

      case ActionTypes.DELETE_RESTAURANT_MENU_MENU_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_DELETE_RESTAURANT_MENU_MENU_ERROR);
        return nextState;

      //
      // MENU - CREATED
      //

      case ActionTypes.POST_RESTAURANT_MENU_MENU_RESPONSE_SUCCESS:
        nextState.restaurantMenu.addMenu(action.menu);
        nextState.createdMenu = action.menu
        nextState.apiError = null;

        this.emitEvent(Events.ON_CREATE_RESTAURANT_MENU_MENU_SUCCESS);
        return nextState;

      case ActionTypes.POST_RESTAURANT_MENU_MENU_RESPONSE_FAILURE:
      case ActionTypes.PUT_RESTAURANT_MENU_MENU_PART_CATEGORY_FAILURE:
      case ActionTypes.PUT_RESTAURANT_MENU_MENU_PART_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_CREATE_RESTAURANT_MENU_MENU_ERROR);
        return nextState;


      case ActionTypes.PUT_RESTAURANT_MENU_MENU_PART_SUCCESS:
       const updatePutPart = (state, action) => {
          const menu = state.restaurantMenu.getMenuWithId(action.menuId);
          menu.updatePart(action.menuPart);
          state.restaurantMenu.updateMenu(menu);
          return state;
        };
        this.emitEvent(Events.ON_UPDATE_RESTAURANT_MENU_MENU_PART_SUCCESS);
        return updatePutPart(nextState, action); 

      //
      // MENU - MENU_PART - CATEGORY
      //
      case ActionTypes.PUT_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS:
        const updatePutCategory = (state, action) => {
          const menu = state.restaurantMenu.getMenuWithId(action.menuId);
          const menuPart = menu.getPartWithId(action.menuPartId);
          menuPart.updateCategory(action.category);
          menu.updatePart(menuPart);
          state.restaurantMenu.updateMenu(menu);
          return state;
        };
        this.emitEvent(Events.ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS);
        return updatePutCategory(nextState, action);

      case ActionTypes.DELETE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS:
        const deleteCategory = (state, action) => {
          const menu = state.restaurantMenu.getMenuWithId(action.menuId);
          const menuPart = menu.getPartWithId(action.menuPartId);
          menuPart.deleteCategory(action.category);
          menu.updatePart(menuPart);
          state.restaurantMenu.updateMenu(menu);
          return state;
        };
        this.emitEvent(Events.ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS);
        return deleteCategory(nextState, action);

      //
      // CATEGORY - UPDATED
      //

      case ActionTypes.PUT_RESTAURANT_MENU_CATEGORY_RESPONSE_SUCCESS:
        nextState.restaurantMenu.updateCategory(new ProductCategory().fromJson(action.category));
        nextState.apiError = null;

        this.emitEvent(Events.ON_UPDATE_RESTAURANT_MENU_CATEGORY_SUCCESS);
        return nextState;

      case ActionTypes.PUT_RESTAURANT_MENU_CATEGORY_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_UPDATE_RESTAURANT_MENU_CATEGORY_ERROR);
        return nextState;

      case ActionTypes.DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_SUCCESS:
        nextState.restaurantMenu.updateCategory(new ProductCategory().fromJson(action.category));
        nextState.apiError = null;

        this.emitEvent(Events.ON_DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_SUCCESS);
        return nextState;

      case ActionTypes.DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_ERROR:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_ERROR);
        return nextState;



      //
      // CATEGORY - DELETED
      //

      case ActionTypes.DELETE_RESTAURANT_MENU_CATEGORY_RESPONSE_SUCCESS:
        nextState.restaurantMenu.deleteCategory(action.category);
        nextState.apiError = null;

        this.emitEvent(Events.ON_DELETE_RESTAURANT_MENU_CATEGORY_SUCCESS);
        return nextState;

      case ActionTypes.DELETE_RESTAURANT_MENU_CATEGORY_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_DELETE_RESTAURANT_MENU_CATEGORY_ERROR);
        return nextState;

      //
      // CATEGORY - CREATED
      //

      case ActionTypes.POST_RESTAURANT_MENU_CATEGORY_RESPONSE_SUCCESS:
        nextState.restaurantMenu.addCategory(action.category);
        nextState.createdCategory = action.category;
        nextState.apiError = null;

        this.emitEvent(Events.ON_CREATE_RESTAURANT_MENU_CATEGORY_SUCCESS);
        return nextState;

      case ActionTypes.POST_RESTAURANT_MENU_CATEGORY_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_CREATE_RESTAURANT_MENU_CATEGORY_ERROR);
        return nextState;

      //
      // UPSELLING_CATEGORY - UPDATED
      //

      case ActionTypes.PUT_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_SUCCESS:
        nextState.restaurantMenu.updateUpsellingCategory(action.upsellingCategory);
        nextState.apiError = null;

        this.emitEvent(Events.ON_UPDATE_RESTAURANT_MENU_UPSELLING_CATEGORY_SUCCESS);
        return nextState;

      case ActionTypes.PUT_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_UPDATE_RESTAURANT_MENU_UPSELLING_CATEGORY_ERROR);
        return nextState;

      //
      // UPSELLING_CATEGORY - DELETED
      //

      case ActionTypes.DELETE_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_SUCCESS:
        nextState.restaurantMenu.deleteUpsellingCategory(action.upsellingCategory);
        nextState.apiError = null;

        this.emitEvent(Events.ON_DELETE_RESTAURANT_MENU_UPSELLING_CATEGORY_SUCCESS);
        return nextState;

      case ActionTypes.DELETE_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_DELETE_RESTAURANT_MENU_UPSELLING_CATEGORY_ERROR);
        return nextState;

      //
      // UPSELLING_CATEGORY - CREATED
      //

      case ActionTypes.POST_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_SUCCESS:
        nextState.restaurantMenu.addUpsellingCategory(action.upsellingCategory);
        nextState.createdUpsellingCategory = action.upsellingCategory;
        nextState.apiError = null;

        this.emitEvent(Events.ON_CREATE_RESTAURANT_MENU_UPSELLING_CATEGORY_SUCCESS);
        return nextState;

      case ActionTypes.POST_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_CREATE_RESTAURANT_MENU_UPSELLING_CATEGORY_ERROR);
        return nextState;

      default:
        return nextState;
    }
  }

}

export default new RestaurantMenuStore();
